var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12" }, [
    _c(
      "div",
      { staticClass: "row header pb-2 pt-2", class: _vm.backgroundClass },
      [
        _c("div", { staticClass: "col-1" }, [
          _c("strong", [_vm._v(_vm._s(_vm.$t("numberShort")))]),
        ]),
        _c("div", { staticClass: "col-4" }, [
          _c("strong", [_vm._v(_vm._s(_vm.$t("kpiMeasure")))]),
        ]),
        _c("div", { staticClass: "col-2" }, [
          _c("strong", [_vm._v(_vm._s(_vm.$t("timeFrameDays")))]),
        ]),
        _vm._m(0),
        _c("div", { staticClass: "col-2" }, [
          _c("strong", [_vm._v(_vm._s(_vm.$t("date")))]),
        ]),
        _c("div", { staticClass: "col-1" }, [
          _c("strong", [_vm._v(_vm._s(_vm.$t("score")))]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2" }, [
      _c("strong", [_vm._v("Status")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }